/**
 * WordPress dependencies
 */
import { createSlotFill } from '@wordpress/components';

var _createSlotFill = createSlotFill('__experimentalInserterMenuExtension'),
    __experimentalInserterMenuExtension = _createSlotFill.Fill,
    Slot = _createSlotFill.Slot;

__experimentalInserterMenuExtension.Slot = Slot;
export default __experimentalInserterMenuExtension;
//# sourceMappingURL=index.js.map